<template>
  <div class="box">
    <div class="screen-body">
      <!-- 第二行 公司行业 -->
      <div class="profession">
        <p class="title">企业行业：</p>
        <div class="con-box">
          <p class="firm-clickable"
            v-for="(item, index) in expList"
            :key="index"
            :style="Exp == item.code ? 'color: #409eff ;' : ''"
            @click="handelClickExp(item.code)"
          >
            {{ item.label }}
          </p>
        </div>
      </div>
      <!-- 第三行 公司规模 -->
      <div class="profession">
        <p class="title">企业规模：</p>
        <div class="con-box">
          <p class="firm-clickable"
            v-for="(item, index) in scaleList"
            :key="index"
            :style="scale == item.id ? 'color: #409eff ;' : ''"
            @click="handelClickScale(item.id)"
          >
            {{ item.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  postGetIndustryTypeSelect, // 行业
} from "../../../../assets/api/indexl";
// 引入切换地址组件
import Address from "../../../../components/Address.vue";
export default {
  data() {
    return {
      list: [
        { name: "推荐职位", id: "1" },
        { name: "JAVA", id: "2" },
      ], // 导航数据
      expList: [
        { name: "不限", id: "1" },
        { name: "互联网/IT/电子/通信", id: "2" },
        { name: "生物医药/医疗", id: "3" },
        { name: "高技术制造业", id: "4" },
        { name: "传统制造业", id: "5" },
        { name: "汽车", id: "6" },
        { name: "房地产/建筑", id: "7" },
        { name: "金融业", id: "8" },
        { name: "教育培训/科研", id: "9" },
        { name: "广告/传媒/文化/体育", id: "10" },
        { name: "批发/零售/贸易", id: "11" },
        { name: "交通运输/仓库管理", id: "12" },
        { name: "专业服务", id: "13" },
        { name: "生活服务", id: "14" },
        { name: "政府/非盈利机构", id: "15" },
        { name: "能源/环保", id: "16" },
      ], // 公司行业
      scaleList: [
        { name: "不限", id: "" },
        { name: "20人以下", id: "0" },
        { name: "20-99人", id: "1" },
        { name: "100-299人", id: "2" },
        { name: "300-499人", id: "3" },
        { name: "500-999人", id: "4" },
        { name: "1000-9999人", id: "5" },
        { name: "10000人以上", id: "6" },
      ], // 公司规模数据

      Exp: "", // 筛选公司行业

      scale: "", // 筛选 公司规模
      dialogAddress: false, // 切换地址
    };
  },
  components: {},
  created() {
    postGetIndustryTypeSelect().then((res) => {
      this.expList = res.data;
      this.expList.unshift({ label: "不限", code: "" });
    });
  },
  mounted() {},
  destroyed() {},
  methods: {
    // 筛选 公司行业
    handelClickExp(num) {
      this.Exp = num;
      this.$emit("handelClickExp", num);
    },

    // 筛选公司规模
    handelClickScale(num) {
      this.scale = num;
      this.$emit("handelClickScale", num);
    },
  },
};
</script>

<style scoped lang="less">
// 筛选区
.box {
  width: 100%;
  height: 100%;
  background: #ffffff;
  // box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 10px;
  display: flex;
  .screen-body {
    width: 1136px;
    min-height: 10px;
    margin: auto;
    font-family: PingFangSC-Medium;
    font-weight: 400;
    // 公司行业
    .profession {
      width: 1100px;
      min-height: 35px;
      line-height: 35px;
      display: flex;
      margin: 15px 20px 15px 20px;
      font-size: 14px;
      color: #333300;

      .title {
        min-width: 10px;
        height: 100%;
        margin-left: 0px;
      }
      .con-box {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      p {
        margin-left: 5px;
        margin-right: 10px;
        cursor: pointer;
      }
    }
    //
  }
}
</style>
